<template>
    <el-dialog
            title="互联网医生工作平台门诊病历首页"
            :visible.sync="jzjlDialogVisible"
            width="60%"
            center>
        <div>
            <div class="header_jzjl">
                <div class="flex aic" style="justify-content: space-between;">
                    <div class="flex aic jcc div_float">
                        <div>姓名:</div>
                        <div class="ml10 pl10 pr10 bottom_border">{{orderInfo.compatName}}</div>
                    </div>
                    <div class="flex aic jcc ml10">
                        <div>性别:</div>
                        <div class="ml10 pl10 pr10">
                            <el-radio v-model="orderInfo.compatGender" label="M" disabled>男</el-radio>
                            <el-radio v-model="orderInfo.compatGender" label="F" style="margin-left: 10px !important;" disabled>女</el-radio>
                        </div>
                    </div>
                    <div class="flex aic jcc ml10">
                        <div>年龄:</div>
                        <div class="ml10 pl10 pr10 bottom_border">{{orderInfo.compatAge}}岁</div>
                    </div>
                    <div class="flex aic jcc ml10">
                        <div>单位:</div>
                        <div class="ml10 pl10 pr10 bottom_border" style="width: 200px;">凤凰医疗集团</div>
                    </div>
                </div>
                <div class="flex aic" style="justify-content: space-between;">
                    <div class="flex aic jcc">
                        <div>科别:</div>
                        <div class="ml10 pl10 pr10 bottom_border">{{orderInfo.bookDeptName}}</div>
                    </div>
                    <div class="flex aic jcc">
                        <div>门诊号:</div>
                        <div class="ml10 pl10 pr10 bottom_border">{{ddxx.jzkh || '暂无'}}</div>
                    </div>
                </div>
            </div>
            <div class="body_jzjl mt5">
                <div class="bottom_border pb5 pt5 pl5">
                    <div class="flex aic" style="justify-content: space-between;">
                        <div class="flex aic jcc">
                            <div>心理情况:</div>
                            <div class="ml10">睡眠:</div>
                            <div>
                                <el-checkbox-group v-model="form.sleepStatus" class="flex">
                                    <el-checkbox label="正常" style="margin-left: 10px !important;">正常</el-checkbox>
                                    <el-checkbox label="困难" style="margin-left: 10px !important;">困难</el-checkbox>
                                    <el-checkbox label="易醒" style="margin-left: 10px !important;">易醒</el-checkbox>
                                    <el-checkbox label="多梦" style="margin-left: 10px !important;">多梦</el-checkbox>
                                    <el-checkbox label="药物" style="margin-left: 10px !important;">药物</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="ml50">白天的精力:</div>
                            <div class="ml10">
                                <el-radio v-model="form.daytimeEnergy" label="是">是</el-radio>
                                <el-radio v-model="form.daytimeEnergy" label="否" style="margin-left: 10px !important;">否</el-radio>
                            </div>
                            <div class="ml10">充沛</div>
                        </div>
                    </div>
                    <div class="flex aic" style="justify-content: space-between;">
                        <div class="flex aic jcc">
                            <div>经济情况:</div>
                            <div>
                                <el-radio-group v-model="form.economicCondition" class="ml20">
                                    <el-radio label="社会医疗保险">社会医疗保险</el-radio>
                                    <el-radio label="公费医疗">公费医疗</el-radio>
                                    <el-radio label="商业保险">商业保险</el-radio>
                                    <el-radio label="农村合作医疗">农村合作医疗</el-radio>
                                    <el-radio label="自费">自费</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="flex aic" style="justify-content: space-between;">
                        <div class="flex aic jcc">
                            <div>社会环境:</div>
                            <div class="ml10">与谁同住:</div>
                            <div>
                                <el-radio-group v-model="form.socialEnvironment" class="ml20">
                                    <el-radio label="家属">家属</el-radio>
                                    <el-radio label="朋友">朋友</el-radio>
                                    <el-radio label="独居">独居</el-radio>
                                    <el-radio label="敬老院">敬老院</el-radio>
                                    <el-radio label="其他">其他</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="flex aic" style="justify-content: space-between;">
                        <div class="flex aic jcc">
                            <div>个性评估:</div>
                            <div>
                                <el-checkbox-group v-model="form.personalityAppraisal" class="flex">
                                    <el-checkbox label="年老体弱" style="margin-left: 10px !important;">年老体弱</el-checkbox>
                                    <el-checkbox label="疼痛" style="margin-left: 10px !important;">疼痛</el-checkbox>
                                    <el-checkbox label="终末疾病" style="margin-left: 10px !important;">终末疾病</el-checkbox>
                                    <el-checkbox label="疑似酒精/药物依赖" style="margin-left: 10px !important;">疑似酒精/药物依赖</el-checkbox>
                                    <el-checkbox label="孕妇" style="margin-left: 10px !important;">孕妇</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <div class="flex aic" style="justify-content: space-between;">
                        <div class="flex aic jcc">
                            <div>弱势群体:</div>
                            <div>
                                <el-radio-group v-model="form.disadvantaged" class="ml20">
                                    <el-radio label="是">是</el-radio>
                                    <el-radio label="否">否</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="ml10">(</div>
                            <div>
                                <el-checkbox-group v-model="form.disadvantagedType" class="flex" :disabled="form.disadvantaged != '是'">
                                    <el-checkbox label="儿童" style="margin-left: 10px !important;">儿童</el-checkbox>
                                    <el-checkbox label=">=70岁" style="margin-left: 10px !important;">>=70岁</el-checkbox>
                                    <el-checkbox label="残疾人" style="margin-left: 10px !important;">残疾人</el-checkbox>
                                    <el-checkbox label="受虐倾向" style="margin-left: 10px !important;">受虐倾向</el-checkbox>
                                    <el-checkbox label="精神/情绪异常" style="margin-left: 10px !important;">精神/情绪异常</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="ml10">)</div>
                        </div>
                    </div>
                </div>
                <div class="pt5 pl5">
                    <div class="flex aic">
                        <div>时间:</div>
                        <div class="ml30">{{ddxx.jzrq + ' ' + ddxx.hysj}}</div>
                    </div>
                    <div class="flex mt10">
                        <div style="width: 50px;">主诉</div>
                        <div class="ml10 mr10" style="flex: 1;">
                            <el-input
                                    type="textarea"
                                    placeholder="请输入主诉内容，最多输入150个字。"
                                    v-model="form.diseaseDescription"
                                    maxlength="150"
                            >
                            </el-input>
                        </div>
                    </div>
                    <div class="flex mt10">
                        <div style="width: 50px;">现病史:</div>
                        <div class="ml10 mr10" style="flex: 1;">
                            <el-input
                                    type="textarea"
                                    placeholder="请输入现病史内容，最多输入150个字。"
                                    v-model="form.nowHistory"
                                    maxlength="150"
                            >
                            </el-input>
                        </div>
                    </div>
                    <div class="flex mt10">
                        <div style="width: 50px;">既往史:</div>
                        <div class="ml10 mr10" style="flex: 1;">
                            <el-input
                                    type="textarea"
                                    placeholder="请输入既往史内容，最多输入150个字。"
                                    v-model="form.pastHistory"
                                    maxlength="150"
                            >
                            </el-input>
                        </div>
                    </div>
                    <div class="flex mt10">
                        <div style="width: 50px;">过敏史:</div>
                        <div class="ml10 mr10" style="flex: 1;">
                            <el-input
                                    type="textarea"
                                    placeholder="请输入过敏史内容，最多输入150个字。"
                                    v-model="form.allergyHistory"
                                    maxlength="150"
                            >
                            </el-input>
                        </div>
                    </div>
                    <div class="flex mt10">
                        <div style="width: 50px;">个人家族史:</div>
                        <div class="ml10 mr10" style="flex: 1;">
                            <el-input
                                    type="textarea"
                                    placeholder="请输入个人家族史内容，最多输入150个字。"
                                    v-model="form.familyHistory"
                                    maxlength="150"
                            >
                            </el-input>
                        </div>
                    </div>
                    <div class="flex mt10" v-if="orderInfo.compatGender != 'M'">
                        <div style="width: 50px;">月经史:</div>
                        <div class="ml10 mr10" style="flex: 1;">
                            <el-input
                                    type="textarea"
                                    placeholder="请输入月经史内容，最多输入150个字。"
                                    v-model="form.mensesHistroy"
                                    maxlength="150"
                            >
                            </el-input>
                        </div>
                    </div>
                    <div class="flex aic mt10 pr10" style="justify-content: space-between;">
                        <div class="flex aic jcc div_float">
                            <div>体检检查:</div>
                            <div class="ml10">血压:</div>
                            <div class="pl5 bottom_border flex" style="width: 40px;">
                                <input type="text" style="width: 100%;height: 100%;" maxlength="3" class="fs14" v-model="form.bloodPressureU">
                            </div>
                            <div class="ml10 mr10 flex aic jcc">/</div>
                            <div class="pl5 bottom_border flex" style="width: 40px;">
                                <input type="text" style="width: 100%;height: 100%;" maxlength="3" class="fs14" v-model="form.bloodPressureD">
                            </div>
                            <div class="ml5">mmHg</div>
                        </div>
                        <div class="flex aic jcc ml10">
                            <div>脉搏:</div>
                            <div class="pl5 bottom_border flex" style="width: 40px;">
                                <input type="text" style="width: 100%;height: 100%;" maxlength="3" class="fs14" v-model="form.pulse">
                            </div>
                            <div class="ml5">次/分</div>
                        </div>
                        <div class="flex aic jcc ml10">
                            <div>体重:</div>
                            <div class="pl5 bottom_border flex" style="width: 40px;">
                                <input type="text" style="width: 100%;height: 100%;" maxlength="3" class="fs14" v-model="form.weight">
                            </div>
                            <div class="ml5">Kg</div>
                        </div>
                        <div class="flex aic jcc ml10">
                            <div>疼痛评分:</div>
                            <div class="pl5 bottom_border flex" style="width: 40px;">
                                <input type="text" style="width: 100%;height: 100%;" maxlength="3" class="fs14" v-model="form.painScore">
                            </div>
                            <div class="ml5">分</div>
                        </div>
                        <div class="flex aic jcc ml10">
                            <div>跌倒评分:</div>
                            <div class="pl5 bottom_border flex" style="width: 40px;">
                                <input type="text" style="width: 100%;height: 100%;" maxlength="3" class="fs14" v-model="form.fallScore">
                            </div>
                            <div class="ml5">分</div>
                        </div>
                    </div>
                    <div class="flex mt10">
                        <div style="width: 50px;">辅助检查:</div>
                        <div class="ml10 mr10" style="flex: 1;">
                            <el-input
                                    type="textarea"
                                    placeholder="请输入辅助检查内容，最多输入150个字。"
                                    v-model="form.supplementaryExamination"
                                    maxlength="150"
                            >
                            </el-input>
                        </div>
                    </div>
                    <div class="flex mt10">
                        <div style="width: 50px;" class="flex aic">诊断:</div>
                        <div class="ml10 mr10" style="flex: 1;">
<!--                            <el-select-->
<!--                                    v-model="form.diagnosisCode"-->
<!--                                    multiple-->
<!--                                    filterable-->
<!--                                    remote-->
<!--                                    reserve-keyword-->
<!--                                    size="small"-->
<!--                                    style="width: 100%;">-->
<!--                                <el-option-->
<!--                                        v-for="item in options"-->
<!--                                        :key="item.value"-->
<!--                                        :label="item.label"-->
<!--                                        :value="item.value">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
                            <el-autocomplete
                                    v-model="form.diagnosisName"
                                    :fetch-suggestions="fetchDiagnosis"
                                    @select="(item)=>{selectDiagnose(item)}"
                                    @keydown.native="deleteDiagnosis"
                                    style="width: 100%;"
                            ></el-autocomplete>
                        </div>
                    </div>
                    <div class="flex mt10 mb10">
                        <div style="width: 50px;">处理:</div>
                        <div class="ml10 mr10" style="flex: 1;">
                            <el-input
                                    type="textarea"
                                    placeholder="请输入处理内容，最多输入150个字。"
                                    v-model="form.handleContent"
                                    maxlength="150"
                            >
                            </el-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="jzjlDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveReport" style="margin-left: 30px !important;">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {tokenCache} from "../../../cache/tokenCache";
    import {isEmpty} from "../../lib/utils"
    export default {
        name: "wlmz-jzjl-make",
        data(){
            return {
                jzjlDialogVisible:false,
                form: {
                    sleepStatus: [],//睡眠情况
                    daytimeEnergy: '',//daytimeEnergy
                    economicCondition: '',//经济情况
                    socialEnvironment:'',//社会环境
                    personalityAppraisal:[],//个性评估
                    disadvantaged:'',//是否弱势群体
                    disadvantagedType:[],//弱势群体说明
                    diseaseDescription:"",//主诉
                    nowHistory:'',//现病史
                    pastHistory:'',//既往史
                    allergyHistory:'',//过敏史
                    familyHistory:'',//个人家族史
                    mensesHistroy:'',//月经史
                    bloodPressureU:'',//血压
                    bloodPressureD:'',
                    pulse:'',//脉搏
                    weight:'',//体重
                    painScore:'',//疼痛评分
                    fallScore:'',//跌倒评分
                    supplementaryExamination:'',//辅助检查
                    diagnosisName:'',//诊断名称
                    diagnosisCode:'',//诊断代码
                    handleContent:'',//处理
                    bloodPressure:''//血压
                },
                baseData:{
                    patName:'张三',//患者姓名
                    patSex:'F',//患者性别
                    patAge:'23',//患者年龄
                    patCompany:'凤凰医疗集团',//患者单位
                    depName:'内分泌',
                    mzh:'123',//门诊号
                },
                diagnosisTemp:'',
                diagnosisTempCode:'',
                orderInfo:{},
                ddxx:{}
            }
        },
        watch:{
            jzjlDialogVisible(newVal){
                if(!this.jzjlDialogVisible){
                    for(let item in this.form){
                        if(this.form[item] instanceof Array){
                            this.form[item] = [];
                        }else{
                            this.form[item] = '';
                        }
                    }
                }
            }
        },
        methods:{
            async show(info,ddxx){
                this.orderInfo = info;
                this.ddxx = ddxx;

                await this.queryReport();
                this.jzjlDialogVisible = true;
            },
            async fetchDiagnosis(queryString = '', cb) {
                const index = queryString.lastIndexOf(';')
                const key = queryString.substring(index + 1, queryString.length);
                const options = {
                    diagnosis: key,
                    token: tokenCache.get(),
                }
                let {code, list} = await this.$http("smarthos.recipe.diagnosis.list", options)
                if (code == '0') {
                    for (let i of list) {
                        i.value = i.diagnosis; //必须绑定value值作为显示数据
                    }

                    cb(list);
                }
            },
            selectDiagnose(item) {

                if (this.diagnosisTemp != '') {
                    let n = this.diagnosisTemp.split(';').length
                    if (n < 6) {
                        this.diagnosisTemp = this.diagnosisTemp + item.diagnosis + ';'
                        this.diagnosisTempCode = this.diagnosisTempCode + item.diagnosisCode + ';'
                    } else {
                        this.$message.error('输入诊断数量不能超过5个！')
                    }
                } else {
                    this.diagnosisTemp = this.form.diagnosisName = this.form.diagnosisName + ';'
                    this.diagnosisTempCode = item.diagnosisCode + ';';
                }
                this.form.diagnosisName = this.diagnosisTemp
                this.form.diagnosisCode = this.diagnosisTempCode
            },
            deleteDiagnosis(e) {
                if (e.keyCode == 8) {
                    const o = this.form.diagnosisName.split(';')
                    const code = this.form.diagnosisCode.split(';')
                    o.splice(o.length - 2, 2)
                    code.splice(code.length - 2, 2)
                    let n = null
                    let c = null;
                    if (o.length >= 1) {
                        n = o.join(";") + ';;'
                        c = o.join(";") + ';;'
                    } else {
                        n = o.join(";")
                        c = o.join(";")
                    }
                    this.form.diagnosisName = this.diagnosisTemp = n
                    this.form.diagnosisCode = this.diagnosisTempCode = c
                }
            },
            async saveReport(){
                this.form.sleepStatus = this.form.sleepStatus.toString();
                this.form.personalityAppraisal = this.form.personalityAppraisal.toString();
                this.form.disadvantagedType = this.form.disadvantagedType.toString();
                this.form.bloodPressure = this.form.bloodPressureU + '-' + this.form.bloodPressureD;
                const {code} = await this.$http('smarthos.online.outpatient.medical.save',{
                    id:this.orderInfo.id,
                    ...this.form
                })
                if(code == 0){
                    this.$message.success('保存病历成功。')
                    this.jzjlDialogVisible = false;
                }
            },
            async queryReport(){
                const {code,obj} = await this.$http('smarthos.online.outpatient.medical.info',{
                    id:this.orderInfo.id
                })
                if(code == 0){
                    if(!isEmpty(obj)){
                        obj.sleepStatus = obj.sleepStatus.split(',') || [];
                        obj.personalityAppraisal = obj.personalityAppraisal.split(',') || [];
                        obj.disadvantagedType = obj.disadvantagedType.split(',') || [];
                        obj.bloodPressureU = obj.bloodPressure.split('-')[0] || '';
                        obj.bloodPressureD = obj.bloodPressure.split('-')[1] || '';
                        this.form = Object.assign({},this.form,obj);
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header_jzjl{
        padding: 0 ;
    }

    .body_jzjl{
        padding: 0;
        border: 1px solid #999999;
    }

    .div_float{
        float: left;
    }

    .bottom_border{
        border-bottom: 1px solid #666666;
    }
</style>